/**
 * 房间层状态错误码
 */
export enum RoomErrorCode {
    /**
     * 房间打开成功
     */
    SUCCESS = 0,
    /**
     * 房间连接超时
     */
    TIMEOUT = 101,
    /**
     * 参数错误
     */
    PARA_ERROR = 102,
    /**
     * 消息已存在
     */
    EXIST = 103,
    /**
     * 网络断开
     */
    ROOM_DISCONNECT = 104,
    /**
     * 房间关闭，弹出离线tips
     */
    ROOM_CLOSE = 105,
    /**
     * 房间断开或者重连状态
     */
    ROOM_STATE_ERR = 106,
    /**
     * 房间被 shutdown
     */
    ROOM_SHUTDOWN = 107,
    /**
     * CGI 响应 status 非 200
     */
    STATUS_ERR = 108,
    /**
     * 大协同连接超时，切换到 websocket
     */
    BIG_COLLAB_CONNECT_TIMEOUT = 109,
}
/**
 * 网络层会处理的错误码集合
 * 附：https://docs.qq.com/sheet/BqI21X2yZIht1zifuQ1oPPrN2R2APY10vdc10Ytyy73GJ2Jx1IQmKC2Cjyb925gSPN4aIIlL0lyChR27cjCd1?tab=BB08J2#tab=BB08J2
 */
export enum RoomWebsocketErrorCode {
    /**
     * 后台回包结果成功
     */
    SOCKET_SERVER_SUCCESS = 0,
    /**
     * 后台发生未知异常错误
     */
    SOCKET_DATA_SERVER_UNKNOWN_ERROR = 10000,
    /**
     * 数据协议字段缺失
     */
    SOCKET_DATA_PROTOCOL_FIELD_LACK = 10001,
    /**
     * 内部错误，请找相应后台负责人查看
     */
    SOCKET_DATA_SERVER_ERROR = 40000,
    /**
     * 文档不存在
     */
    SOCKET_DATA_DOC_NOT_EXIST = 40001,
    /**
     * subId不正确
     */
    SOCKET_DATA_SUBID_ERROR = 40002,
    /**
     * 提交失败（action检查失败：长度不对，回车换行符不对）
     */
    SOCKET_DATA_ACTION_LENGTH = 40003,
    /**
     * changeset easysync 异常
     */
    SOCKET_DATA_CHANGESET_EASYSYNC = 40005,
    /**
     * 数据落盘失败
     */
    SOCKET_DATA_SAVE_FAIL = 40006,
    /**
     * 读数据失败
     */
    SOCKET_DATA_READ_FAIL = 40020,
    /**
     * baseRev错误
     */
    SOCKET_DATA_BASEREV_ERROR = 40021,
    /**
     * 不支持文档类型
     */
    SOCKET_DATA_NOT_SUPPORTED_TYPE = 40022,
    /**
     * 不支持请求协议
     */
    SOCKET_DATA_NOT_SUPPORTED_PROTO = 40023,
    /**
     * 灰度版本号不一致，踢人
     */
    SOCKET_GRAY_VERSION_INCONFORMITY = 40024,
    /**
     * 编辑提交文档被禁止协同
     */
    SOCKET_DOCUMENT_EDIT_COLLAB_LIMIT = 40025,
    /**
     * 编辑提交大小限制 mutation和 keyframe 大小
     */
    SOCKET_DATA_CONTENT_LIMIT = 40026,
    /**
     * 提交数据的base版本号与服务器最新版本差距超过10
     */
    SOCKET_DATA_REV_DIFF_UPPER_TEN = 40027,
    /**
     * 当前提交后台处理协同冲突超时
     */
    SOCKET_DATA_EASYSYNC_TIMEOUT = 40028,
    /**
     * CLIENT_READY 前端js版本过期
     */
    SOCKET_CLIENT_VERSION_TOO_OLD = 40029,
    /**
     * USER_CHANGES 前端js版本过期
     */
    SOCKET_JS_TOO_OLD = 40030,
    /**
     * 前端限制没有冲突编辑提交，（存在冲突）
     */
    SOCKET_NOT_CONFILCT_TO_COMMIT = 40031,
    /**
     * 提交队列被正常提交锁
     */
    SOCKET_COMMIT_QUEUE_NORMAL_LOCK = 40032,
    /**
     * 提交队列被离线提交锁
     */
    SOCKET_COMMIT_QUEUE_OFFLINE_LOCK = 40033,
    /**
     * 编辑提交，dver 版本不一致
     */
    SOCKET_COMMIT_DVER_INCONFORMITY = 40034,
    /**
     * 表格编辑提交，中台服务器错误（需要重试三次）
     */
    SOCKET_SHEET_COMMIT_MIDDLE_SERVER_ERROR = 40035,
    /**
     * 表格编辑提交，提交mutaton格式错误
     */
    SOCKET_SHEET_COMMIT_MUTATION_FORMAT_ERROR = 40036,
    /**
     * 表格编辑提交，提交mutaton apply出错
     */
    SOCKET_SHEET_COMMIT_MUTATION_APPLY_ERROR = 40037,
    /**
     * 前端版本大于后端版本
     */
    SOCKET_WEB_VERSION_GREATER_SERVER_VERSION = 40038,
    /**
     * 表格编辑单元格数，行数、列数超限
     */
    SOCKET_SHEET_ROW_COL_NUMBER_LIIMT = 40039,
    /**
     * 批量提交docid不一致
     */
    SOCKET_DATA_DOCID_ERROR = 41001,
    /**
     * 批量提交协议类型不一致
     */
    SOCKET_DATA_PROTOCOL_TYPE_ERROR = 41002,
    /**
     * 提交冲突处理集合存在还原类型错误码
     */
    COMMIT_CHANGES_CONTAIN_REVERT = 50095,
    /**
     * 内部错误，关闭链接刷新，请找相应后台负责人查看
     */
    SOCKET_SERVER_ERROR = 60000,
    /**
     * 接入层客户端链接不存在，前端重连	reynyuan
     */
    SOCKET_LAYER_ERROR = 60001,
    /**
     * 在ClientReady成功前发协同编辑数据，前端重试
     */
    SOCKET_CLIENT_NOT_READY_ERROR = 60002,
    /**
     * 客户端请求中的数据有错，前端报错
     */
    SOCKET_CLIENT_DATA_ERROR = 60003,
    /**
     * 房间层后台超时，透传上层业务层，前端重试
     */
    SOCKET_COLLAB_ROOM_TIMEOUT = 60004,
    /**
     * 任务层后台超时，，透传上层业务层，前端重试
     */
    SOCKET_COLLAB_SERVER_TIMEOUT = 60005,
    /**
     * 用户登录态校验失败，网络层关闭不重连，需刷新登录，重新登录
     */
    SOCKET_USER_AUTH_FAILED = 60006,
    /**
     * 权限校验完成，用户文档校验失败（权限发生变化），透传给上层，业务处理，对齐权限变更，前端重新刷新
     */
    SOCKET_DOC_PRIVILEGE_FAILED = 60007,
    /**
     * 超过最大包长限制（10M）
     */
    SOCKET_PACKAGE_SIZE_TOO_LARGE = 60008,
    /**
     * clientReady已在房间，前端忽略
     */
    SOCKET_COLLAB_ROOM_ALREADY_EXIST = 60009,
    /**
     * 房间层满员，clientReady处理前端提示（只有clientReady有）
     */
    SOCKET_COLLAB_ROOM_MEMBER_FULL = 60010,
    /**
     * 房间存储层超时，透传给上层，业务处理，前端重试
     */
    SOCKET_SERVER_STORAGE_TIMEOUT = 60011,
    /**
     * 接入层cgi超时，透传给上层，业务处理，前端重试
     */
    SOCKET_SERVER_CGI_TIMEOUT = 60013,
    /**
     * 频率限制，透传给上层，业务处理，前端稍后重试
     */
    SOCKET_FREQUENCY_LIMIT = 60014,
    /**
     * 用户文档权限校验无权限，前端重新刷新，对齐权限变更
     */
    SOCKET_USER_DOC_NOPRIVILEGE = 60015,
    /**
     * userchange 参数错误
     */
    SOCKET_USER_CHANGE_PARAM_ERROR = 60016,
    /**
     * 任务管理层发现不支持命令
     */
    SOCKET_COMMAND_NOT_SUPPORTED = 60017,
    /**
     * commit error：Hackpad调用超时，前端超时
     */
    SOCKET_HACKPAD_TIMEOUT = 60018,
    /**
     * onpost：队列超长，前端延迟重试
     */
    SOCKET_SERVER_WAITTING_TOO_LONG = 60019,
    /**
     * commit error：队列超时，前端延迟重试
     */
    SOCKET_SERVER_WAITTING_TIMEOUT = 60020,
    /**
     * 鉴权超时
     */
    SOCKET_AUTH_TIMEOUT = 60021,
    /**
     * 权限超时
     */
    SOCKET_GET_PRIVILEGE_TIMEOUT = 60022,
    /**
     * IP命中了黑名单,前端block,只可查看
     */
    SOCKET_IP_BLACK_LIST = 60030,
    /**
     * 用户命中了黑名单,前端block,只可查看
     */
    SOCKET_USER_BLACK_LIST = 60031,
    /**
     * 文档命中了黑名单,前端block,只可查看
     */
    SOCKET_DOCMENT_BLACK_LIST = 60032,
    /**
     * userAgent命中了黑名单,前端block,只可查看
     */
    SOCKET_USERAGENT_BLACK_LIST = 60033,
    /**
     * 连接发生变化，需要切换到大协同模式
     */
    SOCKET_SWITCH_BIG_COLLAB = 60034,
    /**
     * 退出大协同模式
     */
    EXIT_BIG_COLLAB = 60035,
    /**
     * 文档被还原，提交的 mutation 无法处理
     */
    DOC_IS_REVERTED = 604459,
    /**
     * chunk 客户端不存在
     */
    CLIENT_NOT_EXIST = 62000,
    /**
     * 重复的连接
     */
    WRITER_IS_EXIST = 62001,
    /**
     * 未知错误
     */
    SOCKET_UNKNOWN_ERROR = -1,
    /**
     * 获取会员失败
     */
    SOCKET_COLLABROOM_GET_VIP_FAIL = 70000,
    /**
     * 登录非会员房间满员
     */
    SOCKET_COLLABROOM_NOT_VIP_FULL = 70001,
    /**
     * 文档已经被删除
     */
    SOCKET_COLLABROOM_DOC_DELETED = 70002,
    /**
     * 连接层 dispose 时关闭房间层错误码
     */
    ROOM_WEBSOCKET_DISPOSE_SHUTDOWN = 1000001,
    /**
     * 后台房间踢人，原因是不活跃或者数据升级类
     */
    INACTIVE = 1000002,
    /**
     * 后台踢人，原因是数据版本dver、pver或者其他不匹配
     */
    CODEREV_NEW = 1000003,
    /**
     * Websocket 提交消息超时
     */
    SOCKET_SEND_MESSAGE_TIMEOUT = 1000004,
    /**
     * 表示登录态失效
     */
    LOGIN_INVALIDATE = 1000005,
    /**
     * 表示登录限制
     */
    LOGIN_FORBIDDEN = 1000006,
}
